module.exports = ".sidebar {\n  width: 300px;\n  position: fixed;\n  z-index: 999;\n  height: 100%; }\n"